import Vue from "vue"

Vue.filter("euro", value => value + ' €')
